"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Upload = require("./Upload.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * 上傳組建可拖移
 */

const {
  Dragger: AntDragger
} = _antd.Upload;
const Upload = _ref => {
  let {
    fileList,
    message = "",
    limit = 999,
    acceptFileType,
    prompt,
    multiple,
    onChange
  } = _ref;
  const [sendFile, setFileSend] = (0, _react.useState)([]);
  const propsUpload = {
    beforeUpload: () => {
      return false;
    },
    onChange(info) {
      const listFiles = info.fileList;
      const newArrayFiles = listFiles.map(file => file.originFileObj ? file.originFileObj : file);
      setFileSend(newArrayFiles);
    },
    multiple,
    showUploadList: true,
    accept: acceptFileType,
    maxCount: multiple ? limit : 1,
    fileList
  };
  (0, _react.useEffect)(() => {
    const nextSendFile = sendFile.filter((item, index) => sendFile.indexOf(item) === index);
    onChange && onChange(nextSendFile);
  }, [sendFile]);
  return /*#__PURE__*/_react.default.createElement(_Upload.UiUpload, null, /*#__PURE__*/_react.default.createElement(AntDragger, _extends({
    name: "file"
  }, propsUpload), /*#__PURE__*/_react.default.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cloud_upload")), /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, "\u4E0A\u50B3\u6A94\u6848"), /*#__PURE__*/_react.default.createElement("p", {
    className: "prompt"
  }, prompt)), message !== "" && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "cancel"), message));
};
var _default = exports.default = Upload;
Upload.propTypes = {
  fileList: _propTypes.default.array,
  message: _propTypes.default.string,
  limit: _propTypes.default.number,
  acceptFileType: _propTypes.default.string,
  prompt: _propTypes.default.element,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  deleteFile: _propTypes.default.func
};